import { render, staticRenderFns } from "./Kinds.vue?vue&type=template&id=2de86cbe"
import script from "./Kinds.vue?vue&type=script&lang=js"
export * from "./Kinds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports